/**
 * =============================================
 * SPARTECH RD — Configuración de integración EBM
 * =============================================
 * Define estas variables en el .env (o en Readdy → Settings → Environment Variables):
 *
 *   VITE_INNOFLEX_BASE_URL    → URL base del servidor EBM
 *                               Ejemplo: https://ebm-api-vvn2.onrender.com
 *
 *   VITE_INNOFLEX_COMPANY_ID  → ID de empresa en EBM (default: "1")
 *
 *   VITE_CATALOG_API_KEY      → API Key generada en EBM → Configuración → API Keys del Catálogo
 *                               Formato: ctlg_XXXXXXXX_XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
 *
 *   VITE_POLLING_INTERVAL     → ms entre actualizaciones silenciosas (0 = desactivado, default 0)
 * =============================================
 */
export const API_CONFIG = {
  BASE_URL:
    (import.meta.env.VITE_INNOFLEX_BASE_URL as string) ||
    'https://ebm-api-vvn2.onrender.com',

  COMPANY_ID:
    (import.meta.env.VITE_INNOFLEX_COMPANY_ID as string) || '1',

  /**
   * API Key para el endpoint público del catálogo.
   * Se envía en el header X-Catalog-Key en cada petición.
   * Genera una desde EBM → POST /api/CatalogApiKeys (requiere JWT de usuario).
   */
  CATALOG_KEY:
    (import.meta.env.VITE_CATALOG_API_KEY as string) || '',

  /** 0 = sin polling (recomendado). Sube a 30_000 si quieres auto-refresh en vivo. */
  POLLING_INTERVAL: Number(import.meta.env.VITE_POLLING_INTERVAL) || 0,

  DEFAULT_PAGE_SIZE: 12,

  WHATSAPP_NUMBER: '18492081166',

  ENDPOINTS: {
    CATALOG: (companyId: string) => `/api/catalog/${companyId}`,
    PRODUCT: (companyId: string, productId: string | number) =>
      `/api/catalog/${companyId}/${productId}`,
    RELATED: (companyId: string, productId: string | number) =>
      `/api/catalog/${companyId}/${productId}/related`,
    CATEGORIES: (companyId: string) => `/api/catalog/${companyId}/categories`,
    BRANDS: (companyId: string) => `/api/catalog/${companyId}/brands`,
  },
} as const;